module.exports = __webpack_public_path__ + "static/media/saw.7ab49314.png";